import { curry, difference, keys, pick, pipe, reduce, toPairs } from "ramda";

type AnyObject = Record<string, unknown>;

export const objectDifferenceLeft = <T extends AnyObject, U extends AnyObject>(
  a: T,
  b: U,
  pickedKeys?: (keyof T)[],
): AnyObject[] => {
  const iteratee = (acc: AnyObject[], [key, value]: [string, unknown]) => {
    acc.push({ [key]: value });
    return acc;
  };
  const k: (keyof T)[] = pickedKeys ?? keys(a);
  // @ts-expect-error rambda uses any
  const _: (obj: AnyObject) => AnyObject[] = pipe(curry(pick)(k), toPairs, (list) => reduce(iteratee, [], list));

  return difference(_(a), _(b));
};
